const { getElement } = window.BAO.Utils
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class SetBuilderBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.mobileCheck = window.matchMedia('(width <= 767px)')
    this.sectionId = this.dataset.sectionId
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onPushCartChanged.bind(this),
    )

    const events = ['scroll', 'resize']
    events.forEach((event) => {
      window.addEventListener(event, this.updatePosition.bind(this))
    })
  }

  updatePosition () {
    const headerHeight = this.externalEls.header.exists
      ? this.externalEls.header.element.offsetHeight
      : 0
    const announcementHeight = this.externalEls.announcement.exists
      ? this.externalEls.announcement.element.offsetHeight
      : 0
    const scrollTop = this.mobileCheck.matches
      ? headerHeight + announcementHeight
      : headerHeight
    const rect = this.getBoundingClientRect()

    document.documentElement.style.setProperty(
      '--Info_Bar_Offset',
      `${headerHeight}px`,
    )

    this.classList.toggle('sb-Bar-fixed', rect.top <= scrollTop)
  }

  async onPushCartChanged () {
    try {
      const res = await fetch(
        `${window.location.pathname}?sections=${this.sectionId}`,
      )
      const resJson = await res.json()
      const parser = new DOMParser()
      const parsedRes = parser.parseFromString(
        resJson[this.sectionId],
        'text/html',
      )

      const html = getElement('[data-set-builder-info-bar]', {
        context: parsedRes,
      }).innerHTML

      this.innerHTML = html
    } catch (err) {
      console.error(err)
    }
  }
}

if (!customElements.get('set-builder-bar')) {
  customElements.define('set-builder-bar', SetBuilderBar)
}

class SetBuilder extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()

    if (!this.els?.info?.exists) return
    this.infoCarousel = this.setupInfoCarousel()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        drag: true,
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 0,
              origin: 'center',
            },
          },
          '(min-width: 900px)': {
            slides: {
              perView: 2.9,
              spacing: 0,
              origin: 'center',
            },
          },
        },
        slideChanged: this.onSlideChanged,
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  onSlideChanged (instance) {
    if (!this.els?.form?.exists) return

    const currentSlide = instance.track.details.rel

    this.els.form.elements.forEach((form, index) => {
      form.setAttribute('aria-current', index === currentSlide)
    })
    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-current', index === currentSlide)
    })
  }

  setupInfoCarousel () {
    return new window.KeenSlider(
      this.els.info.element,
      {
        selector: this.els.form.selector,
        loop: true,
        mode: 'snap',
        drag: false,
        slides: {
          perView: 1,
          spacing: 0,
          origin: 'center',
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('set-builder')) {
  customElements.define('set-builder', SetBuilder)
}
